const legacy_apiUrl = process.env.REACT_APP_LEGACY_APP_LOGIN_URL;
const legacy_secretKey = process.env.REACT_APP_X_API_Key;

export { legacy_apiUrl, legacy_secretKey }